import React, {useRef} from 'react'
import Tree from 'react-hyper-tree'

import { BOULDER } from '@/constants/styles/defaultTheme'
import TreeNodeContainer from '../TreeNode'


import TreeContainer from './styles'

const lineStyles = {
  stroke: BOULDER,
  strokeWidth: 1,
  strokeDasharray: '1 1',
}

const TreeWrapped = ({
  id,
  tree: {
    required,
    handlers,
  },
  isMonitoring,
  selectedNode,
  isSchedule,
  searchQuery,
  onSelectNode,
  checkTree,
  onCheckNode,
  objectsGroupsFilters
}) => {

  const countRef = useRef({})

  const renderNode = (params) => {
    return (
    <TreeNodeContainer
      {...params}
      isMonitoring={isMonitoring}
      isSchedule={isSchedule}
      selectedNode={selectedNode}
      id={id}
      onSelectNode={onSelectNode}
      checkTree={checkTree}
      onCheckNode={onCheckNode}
      countRef={countRef}
      isSearchMode={!!searchQuery}
    />
  )
  }
  return (
    <TreeContainer key={`${id}-container`}>
      <Tree
        key={`${id}-tree`}
        renderNode={renderNode}
        disableTransitions
        disableLines
        // verticalLineOffset={9}
        // verticalLineTopOffset={-9}
        // horizontalLineStyles={lineStyles}
        // verticalLineStyles={lineStyles}
        gapMode="padding"
        depthGap={20}
        classes={{ selectedNodeWrapper: 'selected-node' }}
        {...required}
        {...handlers}
      />
    </TreeContainer>
  )
}

export default React.memo(TreeWrapped)
